import React from "react"
import autobind from "class-autobind"
import FinddWideDrawer from "../../common/FinddWideDrawer"
import { RaisedButton, CircularProgress } from "material-ui"
import strings from "../../../localization/strings"
import DateTimeRangeSelect from "../../common/DateTimeRangeSelect"
import moment from "moment"
import { IDate, IDateRange, IPunchBundle, IUIUser, IActionPunches, IPayrollPayGroupData } from "../../../models"
import * as punchActions from "../../../actions/PunchActions"
import * as payGroupAndTypeHelper from "../../../helpers/payGroupAndTypeHelper"
import * as timecardHelper from "../../../helpers/timecardHelper"
import EditPunchTable from "../EditPunchTable"
import AppStateStore from "../../../stores/AppStateStore"
interface IProps {
    open: boolean
    referenceDate: IDate
    user: IUIUser
    payrollPayGroupData: IPayrollPayGroupData
    handleClose(): void
    handleGenerateTimecard(actionPunches: IActionPunches): void
}
interface IState {
    // start/end date time is browser local time
    startDateTime: IDate
    endDateTime: IDate
    isValidDateRange: boolean,
    dateRangeChanged: boolean,
    loadingPunches: boolean
    punchBundles: IPunchBundle[]
    lockedPeriods: IDateRange[]
}

export default class EmployeeTimecardPunchDrawer extends React.Component<IProps, IState> {
    private dayStartTime24Hour
    private EditPunchTable
    constructor(props: IProps) {
        super(props)
        const timecardDates = timecardHelper.getTimecardDateByPayrollPayGroupData(props.referenceDate, this.props.payrollPayGroupData)
        this.state = {
            startDateTime: timecardDates.StartDate,
            endDateTime: timecardDates.EndDate,
            isValidDateRange: true,
            dateRangeChanged: true,
            loadingPunches: false,
            punchBundles: [],
            lockedPeriods: []
        }
        autobind(this)
        this.dayStartTime24Hour = payGroupAndTypeHelper.getPayGroupByPayrollPayGroupData(this.props.payrollPayGroupData).PaySettings.PayPeriodDayStartTime24Hour
    }

    componentDidMount() {
        this.getPunches()
    }

    componentWillReceiveProps(nextProps: IProps) {
        if (this.props.open !== nextProps.open && nextProps.open) {
            const timecardDates = timecardHelper.getTimecardDateByPayrollPayGroupData(nextProps.referenceDate, this.props.payrollPayGroupData)
            this.setState({
                startDateTime: timecardDates.StartDate,
                endDateTime: timecardDates.EndDate,
                isValidDateRange: true,
                dateRangeChanged: true,
                loadingPunches: false,
                punchBundles: []
            }, () =>
                this.getPunches()
            )
        }
    }

    getPunches() {
        this.props.open &&
            this.setState({ loadingPunches: true, dateRangeChanged: false }, async () => {
                const result = await punchActions.getUserEditablePunchData(this.props.user.Id, moment(this.state.startDateTime).utc(true).format(), moment(this.state.endDateTime).utc(true).format())
                this.setState({
                    loadingPunches: false,
                    punchBundles: result.punchBundle,
                    lockedPeriods: result.lockedPeriods
                })
            })
    }

    handleGenerateTimecard() {
        const { addPunchIds, updatePunchIds, deletePunchIds, errorPunchIds, errorPositionPunchIds } = this.EditPunchTable

        if (errorPunchIds.length > 0 || errorPositionPunchIds.length > 0) return
        const punchBundles = this.EditPunchTable.state.punchBundles as IPunchBundle[]
        const actionPunches: IActionPunches = {
            AddPunches: addPunchIds.map(i => punchBundles.find(punchBundle => punchBundle.Punch.Id === i)),
            UpdatePunches: updatePunchIds.map(i => punchBundles.find(punchBundle => punchBundle.Punch.Id === i)),
            DeletePunchIds: deletePunchIds
        }

        this.props.handleGenerateTimecard(actionPunches)
        this.props.handleClose()
    }

    handleClose() {
        if (this.EditPunchTable) {
            const { addPunchIds, updatePunchIds, deletePunchIds } = this.EditPunchTable
            if (addPunchIds.length > 0 || updatePunchIds.length > 0 || deletePunchIds.length > 0) {
                AppStateStore.setConfirmDialogContent({
                    title: strings.Warning,
                    content: strings.By_closing_this_window_without_selecting_the_VIEW_TIMECARD_button_you_will_lose_your_changes,
                    confirm: () => this.props.handleClose()
                })
            }
            else {
                this.props.handleClose()
            }
        }
        else {
            this.props.handleClose()
        }
    }

    render() {
        const applyBtnDisabled = !this.state.isValidDateRange || !this.state.dateRangeChanged || this.state.loadingPunches
        return (
            <FinddWideDrawer
                open={this.props.open}
                title={`${strings.Add_Edit_Punches}  -  ${this.props.user.FirstName} ${this.props.user.LastName}`}
                handleClose={this.handleClose}
            >
                <div style={{ fontWeight: 600, fontSize: 25 }}>{strings.Edit_Punches}</div>
                <div style={{ fontSize: 15, marginTop: 15, lineHeight: "17px" }}>{strings.Timecard_Punch_Drawer_Alert}</div>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center" }}>
                        <DateTimeRangeSelect
                            dayStartTime24Hour={this.dayStartTime24Hour}
                            startDateTime={this.state.startDateTime}
                            endDateTime={this.state.endDateTime}
                            handleChange={(startDateTime, endDateTime, isValidDateRange, todayClicked) =>
                                todayClicked ?
                                    this.setState({ startDateTime, endDateTime, isValidDateRange }, () => this.getPunches()) :
                                    this.setState({ startDateTime, endDateTime, isValidDateRange, dateRangeChanged: true })
                            }
                        />
                        <RaisedButton
                            data-intercom-target="AddEditPunches-Btn-ApplyFilter"
                            secondary
                            style={{ marginBottom: -10, marginLeft: 5 }}
                            label={strings.Apply_Filter}
                            disabled={applyBtnDisabled}
                            onClick={this.getPunches}
                        />
                    </div>
                    <RaisedButton
                        data-intercom-target="AddEditPunches-Btn-ViewTimecard"
                        secondary
                        style={{ marginBottom: -10 }}
                        label={strings.View_Timecard}
                        disabled={!applyBtnDisabled || this.state.loadingPunches}
                        onClick={this.handleGenerateTimecard}
                    />
                </div>
                {!this.state.dateRangeChanged &&
                    <div style={{overflowX:"auto",marginBottom:28}}>
                        {this.state.loadingPunches ?
                            <div className="spinner"><CircularProgress /></div> :
                            <EditPunchTable
                                ref={item => this.EditPunchTable = item}
                                referenceDate={this.state.startDateTime}
                                user={this.props.user}
                                punchBundles={this.state.punchBundles}
                                lockedPeriods={this.state.lockedPeriods}
                                payrollHierarchyId={this.props.payrollPayGroupData.PayrollHierarchyItemId}
                                payrollPayGroupId={this.props.payrollPayGroupData.PayrollPayGroupId}
                            />
                        }
                    </div>
                }
            </FinddWideDrawer>
        )
    }
}
